import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Exception } from '@cargos/sprintpay-models';
import { IPService } from '@cargos/sprintpay-services';
import { switchMap, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SessionService } from '../../services';
import { CustomerService } from '../../services/customer.service';
import { RouteEventsService } from '../../services/url.service';

@Component({
    selector: 'app-terms-of-use',
    templateUrl: './terms-of-use.component.html',
    styleUrls: ['./terms-of-use.component.scss'],
    standalone: false,
})
export class TermsOfUseComponent {
    public termsOfUseURL = environment.urls?.cargosprintTermsOfUse;
    public isLoading = false;

    constructor(
        private router: Router,
        private location: Location,
        private sessionService: SessionService,
        private matDialog: MatDialogRef<TermsOfUseComponent>,
        private routeEventsService: RouteEventsService,
        private customerService: CustomerService,
        private matSnackBar: MatSnackBar,
        private ipService: IPService
    ) {}

    acceptTerms(): void {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.ipService
            .getIP()
            .pipe(
                take(1),
                switchMap((ip: string) => this.customerService.addCustomerTermsOfUse(ip))
            )
            .subscribe({
                next: () => {
                    this.isLoading = false;
                    this.closeDialog();
                    this.openMessage('You have accepted "Terms of Use"');

                    const previousURL = this.routeEventsService.instant_previous_route_path;

                    if (previousURL) {
                        this.location.back();
                    } else {
                        this.router.navigate(['/']);
                    }
                },
                error: (error: Exception) => {
                    this.isLoading = false;
                    Swal.fire({
                        title: error.title,
                        text: error.description,
                        icon: error.type,
                    });
                },
            });
    }

    declineTerms(): void {
        this.sessionService.logout().pipe(take(1)).subscribe();
    }

    closeDialog(): void {
        this.matDialog.close();
    }

    openMessage(message: string): void {
        this.matSnackBar.open(message, 'Close', {
            duration: 3000,
            horizontalPosition: 'end',
        });
    }
}
